import { type Components, Fade, type Theme } from '@mui/material'

export const MuiTooltip: Components<Theme>['MuiTooltip'] = {
    defaultProps: {
        arrow: true,
        slots: { transition: Fade },
        slotProps: {
            popper: {
                modifiers: [
                    {
                        name: 'preventOverflow',
                        options: {
                            // when tooltip text is too long, it should have padding,
                            // preventing it from being flush against the window edge
                            padding: 16,
                        },
                    },
                ],
            },
        },
    },
    styleOverrides: {
        tooltip: ({ theme }) => ({
            ...theme.typography.body2,
            backgroundColor: theme.palette.grey[900],
            padding: theme.spacing(1.5, 3),
        }),
        arrow: ({ theme }) => ({
            color: theme.palette.grey[900],
        }),
        popper: {
            '&[data-popper-placement*="bottom"]': {
                // overrides popper offsets
                inset: '-5px auto auto 1px !important',
            },
        },
    },
}
